// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2Q2Z4","title":"FrontImage_title__26n3i"};